import { createAction, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  StoreExpenseRemainResponse,
  StoreExpenseRequestListContent,
  StoreExpenseRequestSearchCriteria,
  StoreExpenseViewResponse,
  SubmitStoreExpenseRequest
} from '../models/store-expense.model';

export const StoreExpenseActions = {
  storeExpenseRemainRequest: createAction('[Store Expense] Store Expense Remain Request'),
  storeExpenseRemainResponse: createAction(
    '[Store Expense] Store Expense Remain Response',
    props<{ response: StoreExpenseRemainResponse }>()
  ),
  storeExpenseRequestListRequest: createAction(
    '[Store Expense] Store Expense Request List Request',
    props<{ payload: StoreExpenseRequestSearchCriteria }>()
  ),
  storeExpenseRequestListResponse: createAction(
    '[Store Expense] Store Expense Request List Response',
    props<{ response: Pagination<StoreExpenseRequestListContent> }>()
  ),
  resetStoreExpenseRequestList: createAction('[Store Expense] Reset Store Expense Request List'),
  storeExpenseViewRequest: createAction(
    '[Store Expense] Store Expense View Request',
    props<{ payload: { docNo: string } }>()
  ),
  storeExpenseViewResponse: createAction(
    '[Store Expense] Store Expense View Response',
    props<{ response: StoreExpenseViewResponse }>()
  ),
  resetStoreExpenseView: createAction('[Store Expense] Reset Store Expense View'),

  storeExpenseSubmitRequest: createAction(
    '[Store Expense] Store Expense Submit Request',
    props<{ payload: SubmitStoreExpenseRequest }>()
  ),
  storeExpenseSubmitSendBackRequest: createAction(
    '[Store Expense] Store Expense Submit Send Back Request',
    props<{ payload: SubmitStoreExpenseRequest }>()
  ),
  storeExpenseSubmitResponse: createAction(
    '[Store Expense] Store Expense Submit Response',
    props<{ response: any }>()
  ),
  storeExpenseSubmitClear: createAction('[Store Expense] Store Expense Submit Response Clear')
};
